import React, { useState } from 'react';
import projectsJSON from '../../data/projects.json';
import ProjectCard from '../../components/ProjectCard';
import FilterProjects from '../../components/FilterProjects';
import DropdownFilter from '../../components/DropdownFilter';

const Index = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedTechnology, setSelectedTechnology] = useState("");

    // Get all unique technologies
    const allTechnologies = [...new Set(projectsJSON.flatMap(project => project.technologies))];

    // Filter projects based on the search term and selected technology
    const filteredProjects = projectsJSON.filter(project =>
        (project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        project.technologies.some(tech => tech.toLowerCase().includes(searchTerm.toLowerCase()))) &&
        (selectedTechnology === "" || project.technologies.includes(selectedTechnology))
    );

    const projectCards = filteredProjects.map((project, index) => {
        return (
            <ProjectCard key={index} project={project} />
        )
    });

    return (
        <div className='container mx-auto px-4 py-4 min-h-screen'>
            <div className="flex justify-between items-center my-4">
                <FilterProjects setSearchTerm={setSearchTerm} />
                <DropdownFilter technologies={allTechnologies} setSelectedTechnology={setSelectedTechnology} />
            </div>
            <h1 className='text-6xl my-4'>Projects</h1>
            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 pb-4'>
                {projectCards}
            </div>
        </div>
    );
}

export default Index;